<template>
    <div class="loader"></div>
</template>

<script>
  export default {
    name: 'Loader',
  };
</script>

<style lang="scss" scoped>
  .loader {
    display: inline-block;
    position: relative;
    margin: 10px;
    width: 35px;
    height: 35px;
    top: 50%;
    left: 50%;
    transform: translateX(-50%);
    &:after {
      content: " ";
      display: block;
      width: 35px;
      height: 35px;
      border-radius: 50%;
      border: 4px solid;
      border-color: #cc3333 transparent #cc3333 transparent;
      animation: spin 1.2s linear infinite;
    }
  }
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>
